<div class="mt-6 px-2 max-w-screen-xl">
  <div class="min-w-min w-full">
    <div class="mt-4">
      <app-manual-model-item [tnode]="models"></app-manual-model-item>
    </div>
  </div>
</div>
